/* eslint-disable sort-keys-fix/sort-keys-fix */

import { useTheme } from 'src/utilities/ThemeContext'
import { useMediaQuery } from 'src/utilities/useMediaQuery'

export const Breakpoints = {
  xs: 0,
  sm: 640,
  md: 960,
  lg: 1280,
  xl: 1920
}

export const isSmall = () => useMediaQuery(useTheme().breakpoints.down('xs'))
